import React from "react";
import { Tooltip } from "antd";

interface TruncatedStringProps {
  stringValue: string;
  maxLength: number;
}

const TruncatedString: React.FC<TruncatedStringProps> = ({
  stringValue = "",
  maxLength = 0,
}) =>
  stringValue.length <= maxLength || stringValue.length <= 3 ? (
    <>{stringValue}</>
  ) : (
    <Tooltip placement="bottom" title={stringValue}>
      {`${stringValue.substring(0, maxLength - 3)}...`}
    </Tooltip>
  );

export default TruncatedString;
